import { useSelector } from 'react-redux';
import { FaAngleRight } from 'react-icons/fa';
import { MdInfo } from 'react-icons/md';
import CircleIcon from 'components/CircleIcon';
import DataItem from 'components/DataItem';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { ROUTES_SELF_SERVICE } from 'shared/constants/selfServiceRoutes';
import {
  displayDate,
  getPrimaryFromList,
  getGenderDisplay,
} from 'shared/helpers/common';
import ViewMoreDetails from './ViewMoreDetails';

export default function Details({ userData }) {
  const {
    title,
    fullName,
    dateOfBirth,
    gender,
    addresses = [],
    emailAddress = [],
    phone = [],
  } = userData;

  const { data: addressDisplay } = getPrimaryFromList(addresses, {});
  const { data: emailDisplay } = getPrimaryFromList(emailAddress, {});
  const { data: phoneDisplay } = getPrimaryFromList(phone, {});
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  const { componentConfig } = useSelector(
    (state) => state.ui,
  );

  return (
    <>
      <div className="mt-[40px] flex justify-between items-center">
        <div className="flex items-start">
          <CircleIcon className="mt-1">
            <MdInfo style={{ fill: primaryColour }} />
          </CircleIcon>
          <SectionLabel label="Your details" className="ml-[10px] mt-1" />
        </div>
        {componentConfig.profileEnabled &&
          <ViewMoreDetails
            className="hidden lg:flex"
            label="View your personal details"
            icon={<FaAngleRight />}
            url={ROUTES_SELF_SERVICE.PROFILE}
          />
        }
      </div>
      <div className="rounded-[10px] bg-white w-full py-2 mt-[40px]">
        <div className="font-bold text-lg ml-4 mt-4">Personal</div>
        <div className="mx-4 flex flex-wrap border-b pb-3">
          <DataItem label="Title" value={title} />
          <DataItem label="First name" value={fullName?.first} />
          <DataItem label="Last name" value={fullName?.last} />
          <DataItem label="Date of birth" value={displayDate(dateOfBirth, '-', undefined, true)} />
          <DataItem label="Gender" value={getGenderDisplay(gender)} />
        </div>

        <div className="font-bold text-lg ml-4 mt-4">Address</div>
        <div className="mx-4 flex flex-wrap border-b pb-2">
          <DataItem label="Address line 1" value={addressDisplay?.address1} />
          <DataItem label="Address line 2" value={addressDisplay?.address2} />
          <DataItem label="Address line 3" value={addressDisplay?.address3} />
          <DataItem label="Town / City" value={addressDisplay?.city} />
          <DataItem label="Country" value={addressDisplay?.country} />
          <DataItem label="Postcode" value={addressDisplay?.zipOrPostcode} />
        </div>

        <div className="font-bold text-lg ml-4 mt-4">Contact</div>
        <div className="mx-4 flex flex-wrap pb-3">
          <DataItem label="Contact no." value={phoneDisplay?.visibleNumber} />
          <DataItem label="Contact email" value={emailDisplay?.email} />
        </div>
      </div>
      <ViewMoreDetails
        className="mt-7 lg:hidden"
        label="View your personal details"
        icon={<FaAngleRight />}
        url={ROUTES_SELF_SERVICE.PROFILE}
        isSmallScreen
      />
    </>
  );
}
